import styled, { css } from 'styled-components'
import { ReactComponent as Dots } from 'presentation/assets/icons/three-dots.svg'
import { MenuItem } from '@material-ui/core'

export const Wrapper = styled.div`
  padding-bottom: 24px;
`

export const FiltersWrapper = styled.form`
  margin-top: 32px;
  margin-bottom: 48px;
`

export const DotsIcon = styled(Dots)`
  cursor: pointer;
  path {
    fill: #c0c0c0;
  }
`

export const BoxDefaultCentered = styled.span`
  display: block;
  width: fit-content;
  text-align: center;
  margin: 0 auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 1.3;
  /* font-size: ${({ theme }) => theme.ds.typography.size.xsmall}; */
`

export const BoxDefault = styled.span`
  display: block;
  width: fit-content;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
  /* word-break: break-all; */
  line-height: 1.3;
`

export const CreatedByProfiles = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  > .profile {
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    color: ${({ theme }) => theme.ds.colors.white};
    font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
    background-color: ${({ theme }) => theme.ds.colors.primary400};
    border: 2px solid #d9d9d9;

    &:nth-child(2) {
      z-index: 1;
      margin-left: -8px;
    }

    &:hover {
      z-index: 10;
    }
  }
`

export const HospitalizedBadge = styled.div`
  padding: 4px 8px;
  /* height: 24px; */
  border-radius: 8px;
  font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  color: ${({ theme }) => theme.ds.colors.white};
  background-color: ${({ theme }) => theme.ds.colors.primary500};
`

export const TechniqueBadge = styled.div`
  ${({ theme }) => css`
    padding: 4px 8px;
    /* height: 24px; */
    border-radius: 8px;
    font-weight: ${theme.ds.typography.weight.bold};
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    color: ${({ theme }) => theme.ds.colors.white};
    background-color: ${theme.ds.colors.secondary400};
  `}
`

export const HemoBadge = styled.div`
  ${({ theme }) => css`
    padding: 4px 8px;
    /* height: 24px; */
    border-radius: 8px;
    font-weight: ${theme.ds.typography.weight.bold};
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    color: ${({ theme }) => theme.ds.colors.white};
    background-color: ${theme.ds.colors.terciary300};
  `}
`

export const BadgesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: fit-content;
  margin: 0 auto;
  gap: 4px;

  > .urgency-icon {
    width: 24px;
    height: 24px;
  }
`

export const ModalInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const AlertPanel = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  width: 100%;
  background-color: ${({ theme }) => theme.ds.colors.attention25};
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 30px;
`

export const StatusButtonPanel = styled.div`
  display: flex;
  max-width: 700px;
  justify-content: space-between;
  gap: 10px;
  margin-top: 35px;
  margin-left: auto;
  button {
    width: 45%;
  }
`

export const Title = styled.h3`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.colors.neutralBlack};
`

export const WrapperModal = styled.div`
  width: 560px;
  display: block;
  padding: 25px;
  align-self: center;
`

export const StyledItem = styled(MenuItem)`
  color: ${({ theme }) => theme.colors.primary}!important;
  font-weight: ${({ theme }) => theme.font.bold}!important;
  border-radius: 8px !important;
  padding: 8px !important;
  margin-left: 8px !important;
  margin-right: 8px !important;

  span {
    margin-left: 8px;
  }

  circle {
    display: none;
  }

  svg,
  path {
    fill: ${({ theme }) => theme.colors.primary}!important;
  }

  &:hover {
    background-color: #e4f3e1 !important;
  }
`

export const Filters = styled.form`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 32px;

  .inputs {
    flex: 3;
    min-width: 250px;
  }

  .actions {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
  }
`
